import MainModal from 'src/components/ui/MainModal';
import { useHistory } from 'react-router-dom';
import { Typography, makeStyles } from '@material-ui/core';

import { PathBuilder } from 'src/routing';

interface FaultModalProps {
  alarmFaultCode?: string;
  alarmId: string;
  alarmLearnMore?: string;
  id: string;
  siteId: number;
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: 16,
  },
}));

const FaultModal = ({ alarmFaultCode, alarmId, alarmLearnMore, id, siteId }: FaultModalProps) => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <MainModal
      height={550}
      isOpen
      smallHeader
      onClose={() => history.push(PathBuilder.ALARM_DETAILS(siteId, alarmId, id))}
      onPrimaryAction={() => history.push(PathBuilder.ALARM_DETAILS(siteId, alarmId, id))}
      primaryButtonLabel="Return to Alarm"
      title="View Error Code"
      width={832}
    >
      <Typography className={classes.title}> {alarmFaultCode} </Typography>
      <Typography> {alarmLearnMore} </Typography>
    </MainModal>
  );
};

export default FaultModal;
